const dataStatus = [
    { label: "Aktif", value: "true" },
    { label: "Tidak Aktif", value: "false" },
]

const validationTitle = new RegExp(
    '^[a-zA-Z0-9 ?]*$'
)

const validationUrlLink = new RegExp(
    '(http|https)?://([^ ]+$)'
)

const MENU_NEWS_FEED = {
    dataStatus,
    validationTitle,
    validationUrlLink,

}

export default MENU_NEWS_FEED;